<div class="pad-300 hflex-150">
  <div class="fill-flex">
    @if (tertiaryButton()) {
      <button
        class="mdw-button mdw-tertiary large-button"
        [disabled]="tertiaryButtonDisabled()"
        [icon]="tertiaryButtonIcon()"
        (click)="tertiaryButtonClicked.emit()"
      >
        {{ tertiaryButton() }}
      </button>
    }
  </div>

  @if (showSecondaryButton() && secondaryButton()) {
    <button
      class="mdw-button mdw-secondary large-button"
      [disabled]="secondaryButtonDisabled()"
      [icon]="secondaryButtonIcon()"
      (click)="secondaryButtonClicked.emit()"
    >
      {{ secondaryButton() }}
    </button>
  }
  @if (primaryButton()) {
    <button
      class="mdw-button mdw-primary large-button"
      [disabled]="primaryButtonDisabled()"
      [icon]="primaryButtonIcon()"
      (click)="primaryButtonClicked.emit()"
    >
      @if (primaryButtonLoading()) {
        <mdw-loader class="hflex-150">{{ primaryButton() }}</mdw-loader>
      } @else {
        {{ primaryButton() }}
      }
    </button>
  }
  @if (dangerButton()) {
    <button
      class="mdw-button mdw-danger large-button"
      [disabled]="dangerButtonDisabled()"
      [icon]="dangerButtonIcon()"
      (click)="dangerButtonClicked.emit()"
    >
      {{ dangerButton() }}
    </button>
  }
</div>
